import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./Header.module.css";
import ThemeSwitcher from "./ThemeSwitcher";

// Gazette is the site theme for now. Flip to true to bring back the theme
// menu (also restore the localStorage line in public/index.html so saved
// choices apply before first paint).
const SHOW_THEME_SWITCHER = false;

const Header = ({ headerContent }) => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => { setMenuOpen(false); }, [location]);

  return (
    <header className={styles.header}>
      <Link to="/" className={styles.logo}>{headerContent.name}</Link>

      {/* desktop nav */}
      <nav className={styles.navLinks}>
        <Link to="/"       className={`${styles.navItem} ${location.pathname === "/" ? styles.active : ""}`}>Blog</Link>
        <Link to="/about"  className={`${styles.navItem} ${location.pathname === "/about" ? styles.active : ""}`}>About</Link>
        <Link to="/reading"className={`${styles.navItem} ${location.pathname === "/reading" ? styles.active : ""}`}>Reading</Link>
        <Link to="/music"  className={`${styles.navItem} ${location.pathname === "/music" ? styles.active : ""}`}>Music</Link>
        <Link to="/cv"     className={`${styles.navItem} ${location.pathname === "/cv" ? styles.active : ""}`}>CV</Link>
        <Link to="/github" className={`${styles.navItem} ${location.pathname === "/github" ? styles.active : ""}`}>GitHub</Link>
      </nav>

      {/* desktop theme switcher */}
      {SHOW_THEME_SWITCHER && (
        <div className={styles.themeSlot}>
          <ThemeSwitcher />
        </div>
      )}

      {/* hamburger */}
      <div className={styles.hamburger} onClick={() => setMenuOpen(!isMenuOpen)}>
        <div className={styles.bar}></div>
        <div className={styles.bar}></div>
        <div className={styles.bar}></div>
      </div>

      {/* mobile drawer */}
      <div className={`${styles.mobileMenu} ${isMenuOpen ? styles.mobileMenuActive : ""}`}>
        <button className={styles.closeBtn} onClick={() => setMenuOpen(false)}>✕</button>

        {/* mobile theme switcher (full-width) */}
        {SHOW_THEME_SWITCHER && (
          <div className={styles.mobileThemeSlot}>
            <ThemeSwitcher full />
          </div>
        )}

        <Link to="/"        className={`${styles.mobileNavItem} ${location.pathname === "/" ? styles.active : ""}`}>Blog</Link>
        <Link to="/about"   className={`${styles.mobileNavItem} ${location.pathname === "/about" ? styles.active : ""}`}>About</Link>
        <Link to="/reading" className={`${styles.mobileNavItem} ${location.pathname === "/reading" ? styles.active : ""}`}>Reading</Link>
        <Link to="/music"   className={`${styles.mobileNavItem} ${location.pathname === "/music" ? styles.active : ""}`}>Music</Link>
        <Link to="/cv"      className={`${styles.mobileNavItem} ${location.pathname === "/cv" ? styles.active : ""}`}>CV</Link>
        <Link to="/github"  className={`${styles.mobileNavItem} ${location.pathname === "/github" ? styles.active : ""}`}>GitHub</Link>
      </div>
    </header>
  );
};

export default Header;
